// #root types

export const FETCH_USER = 'FETCH_USER';
export const FETCH_TOKEN = 'FETCH_TOKEN';
export const FETCH_SYNC_USER = 'FETCH_SYNC_USER';
export const SYNC_LOGOUT = 'SYNC_LOGOUT';
export const SET_PERMS = 'SET_PERMS';
export const PUSH_AMIS_EDITOR = 'PUSH_AMIS_EDITOR';
export const POP_AMIS_EDITOR = 'POP_AMIS_EDITOR';
export const UPDATE_AMIS_EDITOR = 'UPDATE_AMIS_EDITOR';
